import TrustBadgePill from './TrustBadgePill';

export default function SupportBadge() {
  return <TrustBadgePill id="support" />;
}
